// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * A single permission action within a menu page.
 */
export class MenuAction implements flatbuffers.IUnpackableObject<MenuActionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MenuAction {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMenuAction(bb: flatbuffers.ByteBuffer, obj?: MenuAction): MenuAction {
    return (obj || new MenuAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMenuAction(bb: flatbuffers.ByteBuffer, obj?: MenuAction): MenuAction {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MenuAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  treeKey(): string | null;
  treeKey(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  treeKey(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  uri(): string | null;
  uri(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  uri(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Permission enabled while the edge runs without cloud connectivity.
   * Mirrors MenuPage.offline at the action level — the frontend's
   * `flattenPermissions()` consults action.offline in non-EDGE mode, so
   * dropping it on a structured round-trip would silently widen
   * offline permissions.
   */
  offline(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  description(): string | null;
  description(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  description(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  locked(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startMenuAction(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(1, +active, +true);
  }

  static addTreeKey(builder: flatbuffers.Builder, treeKeyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, treeKeyOffset, 0);
  }

  static addUri(builder: flatbuffers.Builder, uriOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, uriOffset, 0);
  }

  static addOffline(builder: flatbuffers.Builder, offline: boolean) {
    builder.addFieldInt8(4, +offline, +true);
  }

  static addDescription(builder: flatbuffers.Builder, descriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, descriptionOffset, 0);
  }

  static addLocked(builder: flatbuffers.Builder, locked: boolean) {
    builder.addFieldInt8(6, +locked, +false);
  }

  static endMenuAction(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // name
    return offset;
  }

  static createMenuAction(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    active: boolean,
    treeKeyOffset: flatbuffers.Offset,
    uriOffset: flatbuffers.Offset,
    offline: boolean,
    descriptionOffset: flatbuffers.Offset,
    locked: boolean,
  ): flatbuffers.Offset {
    MenuAction.startMenuAction(builder);
    MenuAction.addName(builder, nameOffset);
    MenuAction.addActive(builder, active);
    MenuAction.addTreeKey(builder, treeKeyOffset);
    MenuAction.addUri(builder, uriOffset);
    MenuAction.addOffline(builder, offline);
    MenuAction.addDescription(builder, descriptionOffset);
    MenuAction.addLocked(builder, locked);
    return MenuAction.endMenuAction(builder);
  }

  unpack(): MenuActionT {
    return new MenuActionT(
      this.name(),
      this.active(),
      this.treeKey(),
      this.uri(),
      this.offline(),
      this.description(),
      this.locked(),
    );
  }

  unpackTo(_o: MenuActionT): void {
    _o.name = this.name();
    _o.active = this.active();
    _o.treeKey = this.treeKey();
    _o.uri = this.uri();
    _o.offline = this.offline();
    _o.description = this.description();
    _o.locked = this.locked();
  }

  unpackFields(...fields: string[]): MenuActionT {
    const t = new MenuActionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("tree_key")) {
      t.treeKey = this.treeKey();
    }
    if (fieldSet.has("uri")) {
      t.uri = this.uri();
    }
    if (fieldSet.has("offline")) {
      t.offline = this.offline();
    }
    if (fieldSet.has("description")) {
      t.description = this.description();
    }
    if (fieldSet.has("locked")) {
      t.locked = this.locked();
    }
    return t;
  }
}

export class MenuActionT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public active: boolean = true,
    public treeKey: string | Uint8Array | null = null,
    public uri: string | Uint8Array | null = null,
    public offline: boolean = true,
    public description: string | Uint8Array | null = null,
    public locked: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const treeKey = this.treeKey !== null ? builder.createString(this.treeKey!) : 0;
    const uri = this.uri !== null ? builder.createString(this.uri!) : 0;
    const description = this.description !== null ? builder.createString(this.description!) : 0;

    return MenuAction.createMenuAction(
      builder,
      name,
      this.active,
      treeKey,
      uri,
      this.offline,
      description,
      this.locked,
    );
  }

  clone(): MenuActionT {
    const obj = new MenuActionT();
    obj.name = this.name;
    obj.active = this.active;
    obj.treeKey = this.treeKey;
    obj.uri = this.uri;
    obj.offline = this.offline;
    obj.description = this.description;
    obj.locked = this.locked;
    return obj;
  }

  equals(other: MenuActionT): boolean {
    if (this.name !== other.name) return false;
    if (this.active !== other.active) return false;
    if (this.treeKey !== other.treeKey) return false;
    if (this.uri !== other.uri) return false;
    if (this.offline !== other.offline) return false;
    if (this.description !== other.description) return false;
    if (this.locked !== other.locked) return false;
    return true;
  }
}

export function verifyMenuAction(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "name");
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 16, 1);
  } finally {
    verifier.popDepth();
  }
}
